var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sectiontitle" },
    [
      _c("span", { staticClass: "sectiontitle-title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c("el-divider", { staticClass: "sectiontitle-line" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }